module.exports = __webpack_public_path__ + "img/pw-spray.a461c761.webp";